/* eslint-disable react/no-unescaped-entities */

import { FC } from "react";

import { LegalDocumentVariables } from "../../types";

export const hu: FC<LegalDocumentVariables> = ({
  lastUpdated,
  company,
  site,
}) => {
  return (
    <div>
      <h1>JOGI NYILATKOZAT</h1>
      <p>
        <strong>Utolsó frissítés: {lastUpdated}</strong>
      </p>
      <h3>WEBOLDAL JOGI NYILATKOZAT</h3>
      <p>
        A(z) {company} („mi”, „minket” vagy „miénk”) által a(z){" "}
        <a href={site}>{site}</a> (a „Weboldal”) webhelyen nyújtott információk
        kizárólag általános tájékoztatási célt szolgálnak. A Weboldalon
        található összes információ jóhiszeműen kerül közlésre, azonban
        semmilyen kifejezett vagy hallgatólagos nyilatkozatot vagy garanciát nem
        vállalunk azok pontosságára, megfelelőségére, érvényességére,
        megbízhatóságára, elérhetőségére vagy teljességére vonatkozóan.
        SEMMILYEN KÖRÜLMÉNYEK KÖZÖTT NEM VÁLLALUNK FELELŐSSÉGET SEMMILYEN
        VESZTESÉGÉRT VAGY KÁRÉRT, AMELY A WEBOLDAL HASZNÁLATÁBÓL VAGY A
        WEBOLDALON KÖZÖLT INFORMÁCIÓKRA VALÓ TÁMASZKODÁSBÓL ERED. A WEBOLDAL
        HASZNÁLATA ÉS AZ OTT KÖZÖLT INFORMÁCIÓKRA VALÓ TÁMASZKODÁS KIZÁRÓLAG A
        SAJÁT FELELŐSSÉGÉRE TÖRTÉNIK.
      </p>
      <h3>KÜLSŐ HIVATKOZÁSOK JOGI NYILATKOZATA</h3>
      <p>
        <strong>A Weboldal</strong> tartalmazhat (vagy a Weboldalon keresztül
        küldhetünk Önnek) harmadik felek webhelyeire vagy azok tartalmára mutató
        hivatkozásokat, illetve reklámszalagokban vagy egyéb hirdetésekben
        található webhelyekre és funkciókra mutató hivatkozásokat. Az ilyen
        külső hivatkozásokat nem vizsgáljuk, nem figyeljük, és nem ellenőrizzük
        azok pontosságát, megfelelőségét, érvényességét, megbízhatóságát,
        elérhetőségét vagy teljességét. NEM VÁLLALUNK GARANCIÁT, NEM
        HITELESÍTJÜK, NEM BIZTOSÍTJUK ÉS NEM VÁLLALUNK FELELŐSSÉGET SEMMILYEN
        HARMADIK FÉL WEBHELYÉN KERESZTÜL ELÉRHETŐ INFORMÁCIÓ PONTOSSÁGÁÉRT VAGY
        MEGBÍZHATÓSÁGÁÉRT, SEM BÁRMILYEN WEBHELYÉRT VAGY FUNKCIÓÉRT, AMELYEKRE
        REKLÁMSZALAGOK VAGY MÁS HIRDETÉSEK MUTATNAK. NEM VESZÜNK RÉSZT ÉS
        SEMMILYEN FORMÁBAN NEM FELELÜNK AZ ÖN ÉS A HARMADIK FÉL SZOLGÁLTATÓI
        KÖZÖTTI TRANZAKCIÓKÉRT.
      </p>
    </div>
  );
};
